import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { Degree } from "@/models/Degree";
import { SortingState } from "@/sorting/SortingState";
import { ISeoMetaDataInfo } from "../../ISeoMetaDataInfo";
import { SeoMetaDataHandler } from "../../SeoMetaDataHandler";
import { SortingOptions } from "@/sorting/SortingOptions";
import { AttendanceFilterOptionValue, FilterKey } from "@studyportals/search-filters";

export class CountryAttendanceOnline extends SeoMetaDataHandler {

	public async canHandle(sortState: SortingState, filterSelectionState: FilterSelectionState): Promise<boolean> {
		const metaRankingSortSelected = await this.sortingOptionSelected(SortingOptions.UNIVERSITY_META_RANKING, sortState);
		const attendanceSelected = await this.singleSelectionFor(FilterKey.DELIVERY_METHOD, filterSelectionState);
		const countrySelected = await this.singleSelectionFor(FilterKey.COUNTRY, filterSelectionState);
		const attendance = this.getFilterOptionValueBy(FilterKey.DELIVERY_METHOD, filterSelectionState);
		const onlyCountryAndAttendanceSelected = await this.selectionOnlyFor([FilterKey.COUNTRY, FilterKey.DELIVERY_METHOD], filterSelectionState);

		return metaRankingSortSelected
			&& onlyCountryAndAttendanceSelected
			&& attendanceSelected
			&& countrySelected
			&& attendance === AttendanceFilterOptionValue.ONLINE;
	}

	protected selfHandle(degree: Degree, filterSelectionState: FilterSelectionState): Promise<ISeoMetaDataInfo> {
		const country = this.getFilterOptionNameBy(FilterKey.COUNTRY, filterSelectionState);
		const year = this.getCurrentYearForSeo();

		const seoInfo = {
			title: `Best Online Universities in ${country} | SP Meta Ranking`,

			description:
				`Explore the top online universities in ${country} for ${year}. ` +
				`Use our complete summary of all ranking providers to find your perfect university. `
		};

		return Promise.resolve(seoInfo);
	}
}
